module.exports = __webpack_public_path__ + "static/media/close119.ceffbcb2.png";